<template>
<div class="card box-shadow-none is-hidden-tablet" v-for="(item, index) in INTERVIEWS" :key="index">
  <div class="card-image">
    <figure class="image">
      <img class="object-fit-contain" :src="item.src" :alt="item.alt">
    </figure>
  </div>
  <div class="card-content">
    <div class="content">
      <p class="title is-5 has-text-theme-green" v-html="item.title"></p>
      <p class="is-size-7 lh-4_1" v-html="item.text"></p>
    </div>
  </div>
</div>

<div class="columns is-gapless is-hidden-mobile my-6" :class="((index % 2) === 1) ? 'is-flex-direction-row-reverse': ''" v-for="(item, index) in INTERVIEWS" :key="index">
  <div class="column">
    <figure class="image">
      <img class="object-fit-contain" :src="item.src" :alt="item.alt">
    </figure>
  </div>
  <div class="column has-background-white mt-5p z-1" :class="((index % 2) === 1) ? 'mr-7n': 'ml-7n'">
    <div class="content p-6">
      <p class="title is-5 has-text-theme-green" v-html="item.title"></p>
      <p class="is-size-6 lh-4_3" v-html="item.text"></p>
    </div>
  </div>
</div>
</template>

<script>
//import config from './../config.json';

const INTERVIEWS = [
  //   {
  //   src: './static_img/interview_01.jpg',
  //   alt: '山崎保育園様',
  //   title: '山崎保育園様',
  //   text: 'ちょうどゲートを作り替えようと思っていたんですけど、金額が高くて迷っていたんですよ。<br>そんな時にDMで補助事業の案内があって『もしかしたら、私たちも申請できるかな』って問い合わせてみました。<br>他の施設様の素敵な事例を拝見していたので安心できました。<br>頼んでみると、手厚くサポートしていただきました。子どもたちも『木の香りがいい匂い』って口を揃えて先生たちに伝えてくれます。'
  // },
  {
    src: './static_img/interview_01.jpg',
    alt: '大阪住吉区 こぐま保育園さま',
    title: '大阪住吉区 こぐま保育園さま <br>特注ロッカー（連絡帳差し付き）',
    text: '・フルオーダー家具のご感想<br>来園者の方が見学した時にひのきの香りがすると言ってくれます。<br>部屋に入るとロッカーと過去に施工頂いた床とマッチしてて凄く嬉しいです。<br><br>・担当者コメント<br>ロッカーとしての機能はもちろん。先生方の連絡帳簿を置けるようにしたい<br>と言う想いにお答えして、納品させて頂きました。<br>違う素材を使わずに木材だけで統一しています。<br>先生たちの「こんなのが欲しい」の想いに対して、私たちは経験を元に向き合い、カタチにしてお届けしています。'
  },
  {
    src: './static_img/interview_02.jpg',
    alt: 'ハッピーチルドレン保育園（IKONIH）',
    title: '八尾市 認定こども園ハッピーチルドレン保育園さま<br>アイコニープール・オプションフェンス・おもちゃ',
    text: '・IKONIHを選んで、一番良かった事はなんですか？<br>1番は「大阪の木を使っている」という事です。地元の木を使って、山を活性化させることに貢献できたと思います。シンプルなものであるが故に、子どもたちの創造力や思考力を鍛える。こういうものが身近に遊び道具としてあることが嬉しい。<br><br>・アイコニープールを使ってみてはいかがですか？<br>子どもの機嫌が悪くなると先生が連れて行って、プールの中で遊ばせて気持ちを落ち着かせていました。中に入って泣いている子はあまりみないですね。肌ざわり・手触りが良いから、これらが子どもたちの感情を落ち着かせているんだと思います。'
  },
  {
    src: './static_img/interview_03.jpg',
    alt: 'らうらうベビールーム保育園',
    title: '大阪市北区 らうらうベビールームさま<br>特注 アクリル仕様 ベビーゲートドア',
    text: '・東野材木店に頼んでよかったなと思ったこと<br>すぐに対応していただけること。スピード感があって良かったです。<br>補助事業の情報があるという事も、最初から教えてくれました。自分達が不安に思わないように対応してくれたことが良かったです。<br>他の会社では「申請はそっちでしてくださいね」と言われてもおかしくないじゃないですか？ 書類をちゃんとチェックしてくれたり、申請までの負担がかなり減ったのが楽だった。<br>申請をしなければならない・・・という時に、サポートがある/ないではかなり違います。'
  },
];

export default {
  name: 'parts-interview',
  components: {
  },
  data() {
    return {}
  },
  computed: {
    INTERVIEWS() {
      return INTERVIEWS;
    }
  }
}
</script>

<style scoped>

.columns {
  margin-bottom: 10% !important;
}

</style>
